var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 27.5C24.5711 27.5 26.25 25.8211 26.25 23.75C26.25 21.6789 24.5711 20 22.5 20C20.4289 20 18.75 21.6789 18.75 23.75C18.75 25.8211 20.4289 27.5 22.5 27.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10C24.5711 10 26.25 8.32106 26.25 6.25C26.25 4.17894 24.5711 2.5 22.5 2.5C20.4289 2.5 18.75 4.17894 18.75 6.25C18.75 8.32106 20.4289 10 22.5 10Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.75C9.57106 18.75 11.25 17.0711 11.25 15C11.25 12.9289 9.57106 11.25 7.5 11.25C5.42894 11.25 3.75 12.9289 3.75 15C3.75 17.0711 5.42894 18.75 7.5 18.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 8.125L10.625 13.125",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 16.875L19.375 21.875",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareAndroid);
export default __webpack_public_path__ + "static/media/share-android.bc151036f644269708bf3515c993ebe6.svg";
export { ForwardRef as ReactComponent };